// Web Audio API sound effects — no external files needed
let ctx: AudioContext | null = null;

const getCtx = (): AudioContext => {
  if (!ctx || ctx.state === 'closed') ctx = new AudioContext();
  if (ctx.state === 'suspended') ctx.resume();
  return ctx;
};

type Tone = [number, number, number]; // [freq, startTime, duration]

const play = (tones: Tone[], type: OscillatorType = 'sine', vol = 0.25) => {
  try {
    const c = getCtx();
    tones.forEach(([freq, t, dur]) => {
      const osc = c.createOscillator();
      const gain = c.createGain();
      osc.type = type; osc.frequency.value = freq;
      osc.connect(gain); gain.connect(c.destination);
      const now = c.currentTime;
      gain.gain.setValueAtTime(0, now + t);
      gain.gain.linearRampToValueAtTime(vol, now + t + 0.01);
      gain.gain.exponentialRampToValueAtTime(0.001, now + t + dur);
      osc.start(now + t); osc.stop(now + t + dur + 0.05);
    });
  } catch (_) {}
};

// 🎵 Student: Correct answer — happy ascending C-E-G-C
export const playCorrectSound = () => play([
  [523, 0, 0.12], [659, 0.1, 0.12], [784, 0.2, 0.12], [1046, 0.32, 0.35],
], 'sine', 0.28);

// 🎵 Student: Wrong answer — sad descending
export const playWrongSound = () => play([
  [350, 0, 0.18], [280, 0.15, 0.18], [220, 0.3, 0.4],
], 'sawtooth', 0.15);

// 🎵 Student: Timer tick (when < 30% time left)
export const playTimerTick = () => play([[900, 0, 0.05]], 'square', 0.08);

// 🎵 Student: Game start fanfare
export const playGameStart = () => play([
  [523, 0, 0.1], [659, 0.12, 0.1], [784, 0.24, 0.1],
  [1046, 0.36, 0.15], [784, 0.52, 0.08], [1046, 0.62, 0.5],
], 'sine', 0.3);

// 🎵 Student: All done — personal result
export const playDone = () => play([
  [784, 0, 0.12], [1046, 0.14, 0.12], [1318, 0.28, 0.4],
], 'sine', 0.28);

// 🎵 Teacher: Small ping — a team answered correctly
export const playAnswerPing = () => play([[880, 0, 0.07]], 'sine', 0.1);

// 🎵 Teacher: Small buzz — a team answered wrong
export const playWrongPing = () => play([[280, 0, 0.07]], 'sawtooth', 0.08);

// 🎵 Teacher: A team finished all questions
export const playTeamFinished = () => play([
  [784, 0, 0.1], [1046, 0.12, 0.1], [1319, 0.24, 0.35],
], 'sine', 0.25);

// 🎵 Teacher: All done — final result fanfare
export const playVictory = () => play([
  [523, 0, 0.1], [659, 0.12, 0.1], [784, 0.24, 0.1], [1046, 0.36, 0.15],
  [784, 0.54, 0.1], [1046, 0.66, 0.55],
], 'sine', 0.3);
